/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';
import ContentDetails from './ContentDetails';
import coursePlanServices from '../../../../redux/services/coursePlanServices';

const DisplayContent = ({
  content, group, contentIds, setContentIds,
}) => {
  useEffect(() => {
    if (group !== undefined
      && group.formationContent !== undefined) {
      setContentIds(group.formationContent);
    }
  }, [group]);

  return (
    <>
      {content.map((item) => (
        <>
          {item.title !== 'GRAMMAR'
            && (
              <Accordion>
                <AccordionSummary>
                  <Grid item md={4}>
                    <Typography>
                      {item.title}
                    </Typography>
                  </Grid>
                  <Grid item md={4}>
                    <Typography>
                      Functional skills
                    </Typography>
                  </Grid>
                  <Grid item md={4}>
                    <Typography>
                      Language skills
                    </Typography>
                  </Grid>
                </AccordionSummary>

                <ContentDetails
                  content={item.skills}
                  group={group}
                  skillTitleId={item.skillTitleId}
                  contentIds={contentIds}
                  setContentIds={setContentIds}
                />
              </Accordion>
            )}
        </>
      ))}
    </>
  );
};

export default DisplayContent;
